import {
    createStore,
    combineReducers,
    applyMiddleware,
    compose
} from 'redux';

import reducers from './reducers';
import middleware from './middleware';

export default (state = {}) => {
    let composeEnhancers = compose;

    if (process.browser) {
        state = window.__REDUX_STATE__;
        delete window.__REDUX_STATE__;

        if (process.env.NODE_ENV === 'development') {
            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        }
    }

    return createStore(
        combineReducers(reducers),
        composeEnhancers(
            applyMiddleware(...middleware)
        )
    );
}



// WEBPACK FOOTER //
// ./src/store/index.js